/**
 * Rémy's Rotating Greetings
 * Each greeting introduces what Rémy can help with.
 * The system picks randomly on each app open, avoiding repeats within a session.
 */

const GREETINGS_POOL = [
  `Good to see you. What are you eating tonight?`,

  `Evening. Tell me what you're cooking and I'll find something in your cellar to go with it.`,

  `Welcome back. Anything you want to open, or anything you want to understand?`,

  `Hello. Ask me what's ready to drink, and I'll tell you why it's ready.`,

  `Good to see you. If there's a bottle you've been unsure about, now's a good time to ask.`,

  `Evening. Got a label to add? Photograph it and I'll do the rest.`,

  `Welcome back. Ask me what's ready to drink now and what's worth holding.`,

  `Hello. Send me a restaurant wine list and I'll tell you what to order and why it's the smart pick.`,

  `Good to see you. Ask me anything about wine and I'll tell you what's behind the answer.`,

  `Evening. What's the occasion?`,

  `Welcome back. Tell me the occasion and I'll narrow it down.`,

  `Hello. Wine question or cellar question, either works.`,
];

let usedIndices: Set<number> = new Set();

/**
 * Returns a random greeting, avoiding repeats within the session.
 * Resets the pool if all greetings have been used.
 */
export function getRandomGreeting(): string {
  // Reset if we've used all greetings
  if (usedIndices.size >= GREETINGS_POOL.length) {
    usedIndices.clear();
  }

  // Find an unused index
  let index: number;
  do {
    index = Math.floor(Math.random() * GREETINGS_POOL.length);
  } while (usedIndices.has(index));

  usedIndices.add(index);
  return GREETINGS_POOL[index];
}

/**
 * Reset the used greetings tracker (call on app unmount if needed)
 */
export function resetGreetings(): void {
  usedIndices.clear();
}

export { GREETINGS_POOL };
